<template>
  <section class="page">
    <div class="level">
      <div class="level-left">
        <h1 class="level-item is-flex align-center">
          <span>{{ title }}</span>
          <span class="mlr-1 loader" v-if="working"></span>
        </h1>
        <slot v-if="$scopedSlots.meta && !loading" name="meta" class="level-item"/>
      </div>
      <div class="level-right" v-if="$scopedSlots.tools && !loading">
        <slot class="level-item" name="tools"/>
      </div>
    </div>
    <slot v-if="!loading"/>
    <p v-else class="has-text-centered ptb-2">{{ loadingText }}</p>
  </section>
</template>

<script>
export default {

  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false
    },
    working: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'Loading…'
    }
  }

}
</script>
